import Meta from '@/components/common/Meta'
import { META_CONTENTS } from '@/v1/constants/seo'
import ShippingToStoragePage from '@/v2/components/pages/public-pages/shipping-to-storage-page'
import { faqSectionContent, metaImages, ogImages } from '@/v2/constants/pages/public-pages/shipping-to-storage-page'

interface ShippingToStoragePageProps {}

const Page: React.FC<ShippingToStoragePageProps> = () => {
  return (
    <>
      <Meta
        title={META_CONTENTS.shipping_to_storage.title ?? ''}
        keywords={META_CONTENTS.shipping_to_storage?.keywords ?? ''}
        description={META_CONTENTS.shipping_to_storage?.description ?? ''}
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
        additionalData={{
          faq: faqSectionContent.questions
        }}
      />

      <ShippingToStoragePage />
    </>
  )
}

export default Page
